import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-mensagem-erro-form',
    imports: [CommonModule],
    standalone: true,
    template: `<small *ngFor="let error of errors">{{ error }}</small>`,
    styles: `small{
        display: block;
        margin: 0.5em 0 0 1em;
        font-weight: 400;
        font-size: 16px;
        line-height: 120%;
        color: #F25757;
    }`
})
export class MensagemErroFormComponent
{
    @Input()
    public formMessage!: AbstractControl | null;

    public get errors(): string[] | null
    {
        let errorMessages: string[] = [];

        if (!this.formMessage?.touched || !this.formMessage?.dirty)
            return null;

        if (!this.formMessage)
            return null;

        const errors = this.formMessage.errors;

        if (!errors)
            return null;

        for (const propertyName in errors)
        {
            const errorMessage = this.getErrorMessage(propertyName, this.formMessage.errors![propertyName]);
            errorMessages.push(errorMessage);
        }

        return errorMessages
    }

    private getErrorMessage(validatorName: string, error: any = null)
    {
        const listOfErrors: any = {
            'required': 'Este campo é obrigatório.',
            'email': 'E-mail inválido.',
            'max': `Valor máximo ${error?.max}. Valor atual ${error?.actual}.`,
            'min': `Valor mínimo ${error?.min}. Valor atual ${error?.actual}.`,
            'maxlength': `Valor máximo ${error?.requiredLength} de caracteres. Valor atual ${error?.actualLength}.`,
            'minlength': `Valor mínimo ${error?.requiredLength} de caracteres. Valor atual ${error?.actualLength}.`,
            'cpf': 'CPF inválido',
            'cnpj': 'CNPJ inválido'
        }
        return listOfErrors[validatorName]
    }
}
